export default "/qq.af70ba09-a44f46.png";